import {
  getIsSelectedAll,
  getSelectedItemIds,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../common';
import { ReactComponent as Checkbox } from '@zonofi/svg-icons/checkbox.svg';
import { ReactComponent as Checked } from '@zonofi/svg-icons/checked.svg';
import './select-all-checkbox-in-header.scss';

interface Props {
  handleToggleSelectAll: () => void;
}
export const SelectAllCheckboxInHeader: React.FC<Props> = ({
  handleToggleSelectAll,
}) => {
  const selectedIds = useAppSelector(getSelectedItemIds);
  const isSelectedAll = useAppSelector(getIsSelectedAll);

  return (
    <div className="select-option-container">
      <TouchableOpacity
        className="select-option-container--left"
        onPress={handleToggleSelectAll}
      >
        {isSelectedAll ? (
          <Checked color="#0067FF" width={20} height={20} />
        ) : (
          <Checkbox color="#8C8C8C" width={20} height={20} />
        )}
        <span className="select-option-container--left-text font-semibold">
          {isSelectedAll ? 'Unselect All' : 'Select All'}
        </span>
      </TouchableOpacity>

      {selectedIds?.length > 0 && (
        <span className="select-option-container--right-text font-semibold">
          {`${selectedIds.length} Selected`}
        </span>
      )}
    </div>
  );
};
